var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("基本信息")]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "content_left" }, [
            _c("div", [
              _c("span", [_vm._v("房间号：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.code || "-"))]),
            ]),
            _c("div", [
              _c("span", [_vm._v("开始时间：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.createTime || "-"))]),
            ]),
            _c("div", [
              _c("span", [_vm._v("会议时长：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.duration || "-"))]),
            ]),
            _c("div", [
              _c("span", [_vm._v("总参会用户数：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.totalNum))]),
            ]),
          ]),
          _c("div", { staticClass: "content_right" }, [
            _c("div", [
              _c("span", [_vm._v("会议状态：")]),
              _c("span", [
                _vm._v(_vm._s(_vm.detailData.status === 1 ? "进行中" : "结束")),
              ]),
            ]),
            _c("div", [
              _c("span", [_vm._v("结束时间：")]),
              _c("span", [_vm._v(_vm._s(_vm.detailData.endTime || "-"))]),
            ]),
            _c("div", [
              _c("span", [_vm._v("当前在线用户数：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.detailData.status === 1 ? _vm.detailData.onlineNum : 0
                  )
                ),
              ]),
            ]),
            _c("div", [
              _c("span", [_vm._v("RTC,IM方案类型：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.detailData.raiType !== ""
                      ? [
                          "即构RTC+即构IM",
                          "网易RTC+网易IM",
                          "腾讯RTC+网易IM",
                          "即构RTC+网易IM",
                        ][+_vm.detailData.raiType]
                      : "-"
                  )
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("供应商信息")]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "content_left" }, [
            _c("div", { staticClass: "content_item" }, [
              _c("span", [_vm._v("云桌面供应商：")]),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detailData.cloudType === 1,
                      expression: "detailData.cloudType === 1",
                    },
                  ],
                },
                [_vm._v("威尔云")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detailData.cloudType === 2,
                      expression: "detailData.cloudType === 2",
                    },
                  ],
                },
                [_vm._v("阿里云")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.detailData.cloudType === 3,
                      expression: "detailData.cloudType === 3",
                    },
                  ],
                },
                [_vm._v("腾讯云")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingBtn,
                      expression: "loadingBtn",
                    },
                  ],
                  staticClass: "_cloud_btn",
                  on: { click: _vm.toCloudDetail },
                },
                [_vm._v("查看详情")]
              ),
            ]),
            _c("div", [
              _c("span", [_vm._v("房间号 ID：")]),
              _c("span", [_vm._v(_vm._s(_vm.$route.query.id || "-"))]),
            ]),
            _c("div", { staticClass: "content_item" }),
          ]),
          _c("div", { staticClass: "content_right" }, [
            _c("div", [
              _c("span", [_vm._v("云桌面 ID：")]),
              _c("span", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.detailData.aliDesktopId || "-") +
                    "\n          "
                ),
              ]),
            ]),
            _c("div", { staticClass: "content_item" }),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "title" }, [_vm._v("成员列表")]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "uid", label: "uid", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.uid || "-") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "username", label: "用户昵称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.username || "-") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "mobile", label: "手机号码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.mobile || "-") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 1
                      ? _c("span", [_vm._v(" 在线 ")])
                      : _c("span", [_vm._v(" 离线")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "dType", label: "类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 0,
                            expression: "scope.row.dType === 0",
                          },
                        ],
                      },
                      [_vm._v(" 移动端-安卓 ")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 1,
                            expression: "scope.row.dType === 1",
                          },
                        ],
                      },
                      [_vm._v(" 移动端-iOS ")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 2,
                            expression: "scope.row.dType === 2",
                          },
                        ],
                      },
                      [_vm._v(" TV端 ")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 3,
                            expression: "scope.row.dType === 3",
                          },
                        ],
                      },
                      [_vm._v(" pc端 ")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 4,
                            expression: "scope.row.dType === 4",
                          },
                        ],
                      },
                      [_vm._v(" MAC ")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 5,
                            expression: "scope.row.dType === 5",
                          },
                        ],
                      },
                      [_vm._v(" H5手机 ")]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.dType === 6,
                            expression: "scope.row.dType === 6",
                          },
                        ],
                      },
                      [_vm._v(" H5电脑 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "ip", label: "ip", width: "150px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(`${scope.row.ip || "-"}`) +
                        "\n        "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(` ${scope.row.address || "-"} `) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "开始时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "leaveTime", label: "结束时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.leaveTime || "-") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "ismain", label: "用户身份" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.ismain === 0
                      ? _c("span", [_vm._v(" 参会人 ")])
                      : scope.row.ismain === 1
                      ? _c("span", [_vm._v(" 房主")])
                      : _c("span", [_vm._v(" '-'")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !scope.row.uid || !_vm.detailData.code,
                          type: "text",
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          "current-page": _vm.params.current,
          "page-sizes": [10, 20, 40, 50, 100],
          "page-size": _vm.params.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }